





































import { Vue, Component, Prop } from 'vue-property-decorator'
import PrizeSelect from './prize-select/index.vue'
@Component({
  components: {
    PrizeSelect
  }
})
export default class TurnTablePrize extends Vue {
  @Prop({
    type: Array,
    default: () => {
      return []
    }
  })
  value!: Array<any>
  currentPrize?: any = null
  currentIndex?: number = null
  prizes = [
    {
      name: '奖品-1',
      isPrize: true
    },
    {
      name: '奖品-2',
      isPrize: true
    },
    {
      name: '奖品-3',
      isPrize: true
    },
    {
      name: '奖品-8',
      isPrize: true
    },
    {
      name: '抽奖',
      isPrize: false
    },
    {
      name: '奖品-4',
      isPrize: true
    },
    {
      name: '奖品-7',
      isPrize: true
    },
    {
      name: '奖品-6',
      isPrize: true
    },
    {
      name: '奖品-5',
      isPrize: true
    }
  ]
  get getCurrentPrize() {
    if (this.currentIndex != null) return this.value[this.currentIndex]
    else return null
  }
  getPrizeName(index: number) {
    let currentPrize = this.value[index]
    if (currentPrize !== undefined && currentPrize.name !== '') {
      return currentPrize.name
    }
    return this.prizes[index].name
  }
  onPrizeChange(e) {
    console.log('on prize change', e)
    this.value[this.currentIndex].name = e.name
    this.value[this.currentIndex].prizeType = e.type
    if (e.type === 0) {
      this.value[this.currentIndex].couponId = e.value
      this.value[this.currentIndex].couponType = e.couponType
      this.value[this.currentIndex].discountValue = e.discountValue
    } else if (e.type === 1) {
      this.value[this.currentIndex].rewardPoint = e.value
    } else {
    }
  }
  setCurrent(index: number) {
    var current = this.prizes[index]
    if (current.isPrize) {
      this.currentIndex = index
      this.currentPrize = this.prizes[index]
    }
  }
  save() {
    this.$emit('on-save')
  }
}
